export const turnOffAutoComplete = () => ({
    autoComplete: 'off',
    // Turnoff password managers: lastpass, 1password
    'data-lpignore': 'true',
    'data-1p-ignore': 'true',
});
